import { Helmet } from '@dr.pogodin/react-helmet';
import { useEffect, useState } from 'react';
import Loading from '../common/lib/Loading';
import PageNotFound from '../common/lib/PageNotFound';
import XoopsCode from '../common/lib/XoopsCode';
import type { MultiLang } from '../config';
import Functions from '../functions';
import type CosmoDbContext from './lib/CosmoDbContext';
import type { CosmoDbDetailData } from './lib/CosmoDbContext';

interface Props {
    lang: MultiLang;
    context: CosmoDbContext;
    id: number;
    tab: number;
}

interface LoadedDetail {
    context: CosmoDbContext;
    id: number;
    detail: CosmoDbDetailData | null;
}

const CosmoDbDetail = (props: Props) => {
    const { lang, context, id, tab } = props;
    const basic = context.getBasic(id);
    const [loaded, setLoaded] = useState<LoadedDetail | null>(null);

    useEffect(() => {
        let active = true;
        context.getDetail(id).then((detail) => {
            if (active) {
                setLoaded({ context, id, detail });
            }
        });
        return () => {
            active = false;
        };
    }, [context, id]);

    if (basic === null) {
        return <PageNotFound lang={lang} />;
    }
    // A detail loaded for the previous item must not be shown for this one.
    if (loaded === null || loaded.context !== context || loaded.id !== id) {
        return <Loading />;
    }
    if (loaded.detail === null) {
        return <PageNotFound lang={lang} />;
    }
    const html = context.renderDetail(basic, loaded.detail, tab);
    return (
        <div className="detail">
            <Helmet>
                <title>
                    {Functions.mlang(basic.label, lang)} - {Functions.mlang(context.getModuleName(), lang)} -{' '}
                    {Functions.siteTitle(lang)}
                </title>
            </Helmet>
            <XoopsCode lang={lang} text={html} dohtml={true} />
        </div>
    );
};

export default CosmoDbDetail;
